import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Base URL for every protected backend route. */
export const API = `${BACKEND_URL}/api`;

/**
 * POST with one automatic retry on transient errors (5xx from the preview
 * proxy or a network error). Vision calls can take ~30s and occasionally the
 * first cold call returns 502 — retrying once almost always succeeds and
 * keeps the trick smooth on stage.
 */
export async function postWithRetry(url, data, opts = {}) {
  const cfg = { timeout: 60000, ...opts };
  try {
    return await axios.post(url, data, cfg);
  } catch (err) {
    const status = err?.response?.status;
    const isTransient =
      !err?.response ||
      status === 502 || status === 503 || status === 504 || status === 408;
    if (!isTransient) throw err;
    await new Promise((r) => setTimeout(r, 1200));
    return await axios.post(url, data, cfg);
  }
}
